<template>
  <div>
    <div class="grid-container" :style="{ gridTemplateColumns: gridTemplateColumns }">
      <!-- Main Headers -->
      <div class="main-header sticky-col kg-desi-header min-header" style="z-index: 11">
        {{ $t('KG / Desi') }}
      </div>
      <div
        class="main-header bolgeler-header"
        :style="{ gridColumn: 'span ' + data.columns.length }"
      >
        {{ $t('Regions') }}
      </div>

      <!-- Sub-Headers -->
      <div class="sub-header sticky-col min-header" style="z-index: 11">{{ $t('Min. Value') }}</div>
      <div class="sub-header sticky-col max-header" style="z-index: 11">{{ $t('Max. Value') }}</div>
      <div v-for="region in data.columns" :key="region.id + '_region'" class="sub-header">
        {{ $t(region.name) }}
      </div>

      <!-- Data Rows -->
      <div v-for="(row, rowIndex) in data.rows" :key="rowIndex" class="grid-row">
        <div class="grid-item sticky-col min-header" :style="{ gridRow: 3 + rowIndex }">
          {{ row.min_val }}
        </div>
        <div class="grid-item sticky-col max-header" :style="{ gridRow: 3 + rowIndex }">
          {{ row.max_val }}
        </div>
        <div
          v-for="(price, colIndex) in row.region_prices"
          :key="colIndex"
          class="grid-item"
          :style="{ gridRow: 3 + rowIndex }"
        >
          {{ price || '-' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegionPricingTableView',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    gridTemplateColumns() {
      // İlk iki sütun sabit genişlikte, diğerleri bölgeler kadar tekrar eder
      const fixedFirstCols = '150px 150px';
      const regionColWidth = '180px';
      const regionCols = Array(this.data?.columns?.length || 0)
        .fill(regionColWidth)
        .join(' ');
      return `${fixedFirstCols}${regionCols ? ` ${regionCols}` : ''}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container {
  max-height: 500px;
  overflow-y: auto;
  display: grid;
  /* Varsayılan; gerçek şablon inline style ile ayarlanır */
  grid-template-columns: 150px 150px;
  grid-template-rows: auto auto;
  overflow-x: auto;
  position: relative;
}

.main-header,
.sub-header,
.grid-item {
  text-align: center;
  padding: 10px;
  background-color: #f0f4c3; /* Lighter, more pleasant yellow */
  font-weight: bold;
  white-space: nowrap;
  border: 1px solid #e0e0e0;
}

.main-header {
  top: 0;
  position: sticky;
  height: 40px;
  display: flex;
  align-items: center;
}

.sub-header {
  grid-row: 2;
  position: sticky;
  top: 40px; /* main-header yüksekliği ile hizalı */
}

.kg-desi-header {
  grid-column: 1 / 3;
  background-color: #ffecb3; /* Softer gold */
  grid-row: 1;
  z-index: 10;
}

.bolgeler-header {
  grid-column: 3 / -1;
  grid-row: 1;
  background-color: #ffecb3; /* Softer gold */
}

.sticky-col {
  position: sticky;
  z-index: 9;
}

/* Min. Değer ve Max. Değer konum ayarları */
.min-header {
  left: 0;
}

.max-header {
  left: calc(150px);
  /* Sütun genişliğine göre dinamik olarak hesaplanır */
}

.grid-row {
  display: contents;
}

.grid-item {
  background-color: #ffffff; /* Pure white for better contrast */
  border: 1px solid #e0e0e0; /* Lighter border */
}

/* Dark mode styles */
body.dark-layout {
  .main-header,
  .sub-header,
  .grid-item {
    background-color: #2d3748; /* Dark gray background */
    color: #e2e8f0; /* Light text color */
    border: 1px solid #4a5568; /* Darker border */
  }

  .kg-desi-header,
  .bolgeler-header {
    background-color: #4a5568; /* Darker gold for headers */
    color: #f7fafc; /* Light text color */
  }

  .grid-item {
    background-color: #1a202c; /* Dark background for data cells */
    color: #e2e8f0; /* Light text color */
    border: 1px solid #4a5568; /* Darker border */
  }
}
</style>
